<div class="generation-status" [ngClass]="{'generation-status--repositioned': status.reposition}">
  <section class="generation-status--section" *ngIf="!status.failed">
    <div class="generation-status__spinner" *ngIf="status.loading || forceSpinner">
      <mat-spinner strokeWidth="5" diameter="32"></mat-spinner>
    </div>
    <div class="generation-status__text">
      {{ status.text }}
    </div>
  </section>
  <section class="generation-status--error" *ngIf="status.failed">
    <div class="generation-status--error__message" *ngIf="status.error.reason">
      <mat-icon svgIcon="information-icon"></mat-icon>
      <span>{{ status.error.reason }}</span>
    </div>
    <div class="generation-status--error__buttons" *ngIf="status.retry.available">
      <q9-primary-button [disabled]="forceSpinner" (click)="retry()">
        {{ 'AUTOGENERATE_DRILLDOWN.RETRY_LABEL' | translate }}
      </q9-primary-button>
      <q9-secondary-button [disabled]="forceSpinner" (click)="cancel()">
        {{ 'POPUPS.CANCEL' | translate }}
      </q9-secondary-button>
    </div>
  </section>
</div>
